module.exports = __webpack_public_path__ + "img/success.f28f7a85.svg";